import settings from 'components/pages/settings/Settings';

export default settings;
